// extracted by mini-css-extract-plugin
export default {"Applications":"styles_Applications__w6IUU","noData":"styles_noData__Y0GQT"};